export default defineNuxtRouteMiddleware((to) => {
	if (to.name === 'branch' && to.params.branch === 'globus') {
		return navigateTo('/o-nas/sidlo-spolecnosti');
	}
});
